import { render, staticRenderFns } from "./SalaAtendimento.vue?vue&type=template&id=35d7552e&scoped=true&"
import script from "./SalaAtendimento.vue?vue&type=script&lang=js&"
export * from "./SalaAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./SalaAtendimento.vue?vue&type=style&index=0&id=35d7552e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d7552e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
